module.exports = __webpack_public_path__ + "img/Dantam Fashion 13.61d75aac.jpg";